import React, { FC, ReactElement, useMemo, useState } from 'react';
import { TooltipBody, TooltipCont } from './Tooltip.styles';
import { CaptionRegularL } from '../../styles/globals';

interface ITooltip {
  children: ReactElement;
  className?: string;
  tooltipDesc: string | ReactElement;
  position?: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
  arrowPositionX?: string;
  background?: string;
  width?: string;
}

const Tooltip: FC<ITooltip> = ({
  children,
  className,
  tooltipDesc,
  position = 'bottom',
  positionX,
  positionY,
  arrowPositionX,
  background,
  width,
}) => {
  const [active, setActive] = useState(false);

  const renderTooltipBody = useMemo(
    () =>
      active && (
        <TooltipBody
          id="TooltipBody"
          data-testid="tooltipBody"
          width={width}
          position={position}
          positionX={positionX}
          positionY={positionY}
          background={background}
          arrowPositionX={arrowPositionX}
        >
          <CaptionRegularL id="CaptionRegularL" data-testid="tooltipBody">
            {tooltipDesc}
          </CaptionRegularL>
        </TooltipBody>
      ),
    [tooltipDesc, active]
  );
  return (
    <TooltipCont
      className={className}
      data-testid="TooltipCont"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      {children}
      {renderTooltipBody}
    </TooltipCont>
  );
};

export default Tooltip;
